import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import MainInfoComponent from '../components/common/MainInfoComponent';
import MainDataShowup from '../components/common/MainDataShowup';
import DonateRM from '../components/pagedata/donateRM';
import { useLocation } from 'react-router-dom';
import donatebkc from '../assets/backgorund/donatebkc.jpg';
import ImageCarousel from '../components/ImageCarousel'
import DonationWays from '../components/DonationWays';
const Donate = () => {
  const [readMore, setReadMore] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setReadMore(false);
  }, [location]);
  return (
    <div id="mainDataShowup" >
    {!readMore && 
      <ImageCarousel images={[donatebkc]} title = "Make a Lasting Impact – Donate Today!"/>}
      <AnimatePresence mode="wait">
        {readMore ? (
          <motion.div
            key="MainDataShowup"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5 }}
          >
            <MainDataShowup childComponent={DonateRM} />
          </motion.div>
        ) : (
          <MainInfoComponent
            // heading="your donation"
            // subheading="Make a Lasting Impact – Donate Today!"
            para={
              <>
                 <span style={{ color: "var(--nav-letter" }}>
                  Your generosity has the power to{' '}
                  <strong style={{ color: "var(--nav-letter)" }}>transform lives of our children.</strong>{' '}
                  At Snehwan, every contribution—no matter the size—plays a crucial role in helping us provide essential services and support to those in need.
                  When you donate, you are not just giving money; you are{' '}
                  <strong style={{ color: "var(--nav-letter)" }}>investing in hope, opportunity, and a brighter future for children at Snehwan.</strong>
                </span>
              </>
            }
            // readMore="Donate now"
            // onReadMore={() => setReadMore(true)}
          />
         
        )}
        <div style={{ width: '80%', margin: '2rem auto' }}>
        <DonateRM />
        </div>
        <DonationWays />

      </AnimatePresence>
    </div>
  );
};
export default Donate;
